import React, { useState } from "react";
import Icon, { IconColors, IconTypes } from "@sendbird/uikit-react/ui/Icon";
import getStringSet from "../../localization/chatStringSet";
import LeaveChannel from "@sendbird/uikit-react/ChannelSettings/components/LeaveChannel";

export const ChatLeaveChannelMenuItem: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const stringSet = getStringSet();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        className="sendbird-channel-settings__panel-item sendbird-channel-settings__panel-item__leave-channel"
        onClick={handleOpenModal}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            handleOpenModal();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <Icon
          className="sendbird-channel-settings__panel-icon-left sendbird-channel-settings__panel-icon__leave"
          type={IconTypes.LEAVE}
          fillColor={IconColors.ERROR}
          height="24px"
          width="24px"
        />
        <span className="sendbird-label sendbird-label--subtitle-1 sendbird-label--color-onbackground-1">
          {stringSet.CHANNEL_SETTING__LEAVE_CHANNEL__TITLE}
        </span>
      </div>
      {isModalOpen && (
        <LeaveChannel onSubmit={() => undefined} onCancel={handleCloseModal} />
      )}
    </>
  );
};
